/**
 * @class
 * @classdesc A wrapper around Map with utility methods for config access.
 */
var ConfigMap = /** @class */ (function () {
    /**
     * @param {Object|Array<[string, string]>} initialEntries
     */
    function ConfigMap(entries) {
        if (entries === void 0) { entries = []; }
        // Internal map instance
        this._map = new Map(entries);
    }
    /**
     * @param {string} key
     * @param {*} defaultValue
     * @returns {*}
     */
    ConfigMap.prototype.getValue = function (key, defaultValue) {
        var _a;
        return (_a = this._map.get(key)) !== null && _a !== void 0 ? _a : defaultValue;
    };
    /**
     * @param {string} key
     * @param {boolean} defaultValue
     * @returns {boolean}
     */
    ConfigMap.prototype.isEnabled = function (key, defaultValue) {
        // for quick testing
        // if (key === "quickSenderID") return true;
        if (this._map.has(key)) {
            return (String(this._map.get(key)) === "true" ||
                String(this._map.get(key)) === "1");
        }
        else {
            return defaultValue;
        }
    };
    /** @returns {Map<string, string>} */
    ConfigMap.prototype.getMap = function () {
        return this._map;
    };
    return ConfigMap;
}());
export { ConfigMap };
